import Chip001 from './chips_2/chip_0_01.svg';
import Chip005 from './chips_2/chip_0_05.svg';
import Chip025 from './chips_2/chip_0_25.svg';
import Chip1 from './chips_2/chip_1.svg';
import Chip5 from './chips_2/chip_5.svg';
import Chip25 from './chips_2/chip_25.svg';
import Chip100 from './chips_2/chip_100.svg';
import Chip500 from './chips_2/chip_500.svg';
import Chip1000 from './chips_2/chip_1000.svg';
import Chip5000 from './chips_2/chip_5000.svg';
import Chip25000 from './chips_2/chip_25000.svg';
import { PokerChipValue } from './PokerChipValue';

const chipSVGs = {
  [PokerChipValue.ONE_CENT]: Chip001,
  [PokerChipValue.FIVE_CENT]: Chip005,
  [PokerChipValue.TWENTY_FIVE_CENT]: Chip025,
  [PokerChipValue.ONE]: Chip1,
  [PokerChipValue.FIVE]: Chip5,
  [PokerChipValue.TWENTY_FIVE]: Chip25,
  [PokerChipValue.ONE_HUNDRED]: Chip100,
  [PokerChipValue.FIVE_HUNDRED]: Chip500,
  [PokerChipValue.ONE_THOUSAND]: Chip1000,
  [PokerChipValue.FIVE_THOUSAND]: Chip5000,
  [PokerChipValue.TWENTY_FIVE_THOUSAND]: Chip25000,
};

export const PokerChip = ({ value }: { value: PokerChipValue }) => {
  const SvgComponent = chipSVGs[value];

  if (!SvgComponent) {
    console.error('Chip SVG not found for value:', value);
    return <p>Error loading the chip image.</p>;
  }

  return <img className="h-6 w-6 min-w-5 max-w-12" src={SvgComponent} alt={`Chip ${value}`} />;
};
